<template>
  <div class="map-filters">
    <b-card class="mb-0 p-1">
      <div class="filter-section mb-2">
        <div class="filter-header d-flex justify-content-between align-items-center cursor-pointer" @click="showSearch = !showSearch">
          <span class="mb-0 font-weight-bold cursor-pointer">{{ $gettext('Search Elements') }}</span>
          <i :class="['fa', showSearch ? 'fa-chevron-up' : 'fa-chevron-down']" class="text-muted cursor-pointer"></i>
        </div>
        <b-collapse v-model="showSearch">
          <div class="d-flex flex-column gap-2 mt-2">
            <geofence-autocomplete @selected="centerOn($event)" :placeholder="$gettext('Search Geofence...')" :disabled="disabled" />
            <geopoint-autocomplete @selected="centerOn($event)" :placeholder="$gettext('Search GeoPoint...')" :disabled="disabled" />
            <geoline-autocomplete @selected="centerOn($event)" :placeholder="$gettext('Search GeoLine...')" :disabled="disabled" />
          </div>
        </b-collapse>
      </div>

      <hr class="my-2">

      <div class="filter-section">
        <div class="filter-header d-flex justify-content-between align-items-center cursor-pointer" @click="showNearby = !showNearby">
          <span class="mb-0 font-weight-bold cursor-pointer">{{ $gettext('Show Nearby Elements') }}</span>
          <i :class="['fa', showNearby ? 'fa-chevron-up' : 'fa-chevron-down']" class="text-muted cursor-pointer"></i>
        </div>
        <b-collapse v-model="showNearby" class="mt-2">
          <indeterminate-checkboxes all-selected :parent-title="$gettext('GeoFences') + ` (${counters.polygonTypes})`" :parent-title-all-selected="$gettext('GeoFences') + ` (${counters.polygonTypes})`" v-model="filters.polygonTypes" :child-options="computedGeoTypesSelect.filter(x => x.type === 'polygon')" :disabled="disabled" />
          <indeterminate-checkboxes all-selected :parent-title="$gettext('GeoLines') + ` (${counters.lineTypes})`" :parent-title-all-selected="$gettext('GeoLines') + ` (${counters.lineTypes})`" v-model="filters.lineTypes" :child-options="computedGeoTypesSelect.filter(x => x.type === 'linestring')" :disabled="disabled" />
          <indeterminate-checkboxes all-selected :parent-title="$gettext('GeoPoints') + ` (${counters.pointTypes})`" :parent-title-all-selected="$gettext('GeoPoints') + ` (${counters.pointTypes})`" v-model="filters.pointTypes" :child-options="computedGeoTypesSelect.filter(x => x.type === 'point')" :disabled="disabled" />
        </b-collapse>
      </div>
    </b-card>
  </div>
</template>

<script>
import IndeterminateCheckboxes from '@/components/IndeterminateCheckboxes'
import GeofenceAutocomplete from '@/components/Autocompletes/GeofenceAutocomplete'
import GeolineAutocomplete from '@/components/Autocompletes/GeolineAutocomplete'
import GeopointAutocomplete from '@/components/Autocompletes/GeopointAutocomplete'

export default {
  emits: ['center-on', 'filters-changed'],
  name: 'GeoTypesControl',
  components: {
    IndeterminateCheckboxes,
    GeofenceAutocomplete,
    GeolineAutocomplete,
    GeopointAutocomplete
  },
  data() {
    return {
      counters: {
        polygonTypes: 0,
        lineTypes: 0,
        pointTypes: 0
      },
      showSearch: true,
      showNearby: true,
      filters: {
        polygonTypes: [],
        lineTypes: [],
        pointTypes: []
      },
      disabled: false
    }
  },
  computed: {
    computedGeoTypesSelect() {
      return this.geoTypes.map(x => {
        return {
          text: this.toTitleCase(x.name),
          value: x.id,
          type: x.type
        }
      })
    }
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        this.$emit('filters-changed', this.filters)
      }
    },
    '$parent.disableStuff': {
      handler(val) {
        this.disabled = val
      },
      deep: true
    },
    '$parent.counters': {
      handler(val) {
        this.$set(this.counters, 'polygonTypes', val.geofences_self)
        this.$set(this.counters, 'lineTypes', val.geolines_self)
        this.$set(this.counters, 'pointTypes', val.geopoints_self)
      },
      deep: true
    }
  },
  methods: {
    centerOn(item) {
      this.$emit('center-on', item)
    }
  }
}
</script>

<style>
.cursor-pointer {
  cursor: pointer;
}
</style>
